import {
  FORKSEEK_CONTINUATION_FALLBACK,
  normalizeForkSeekPaidPlanKey,
  sanitizeForkSeekContinuation,
  type ForkSeekContinuationPurpose,
} from '../../supabase/functions/_shared/forkSeekAuthContinuation';

export function sanitizeForkSeekReturnTo(
  value: string | null | undefined,
  purpose: ForkSeekContinuationPurpose,
) {
  return sanitizeForkSeekContinuation(value, purpose);
}

export function getForkSeekPostAuthPath(
  value: string | null | undefined,
  purpose: ForkSeekContinuationPurpose,
) {
  return sanitizeForkSeekReturnTo(value, purpose) ?? FORKSEEK_CONTINUATION_FALLBACK;
}

export function getForkSeekAuthPathWithReturn(location: Pick<Location, 'pathname' | 'search' | 'hash'>) {
  const target = sanitizeForkSeekReturnTo(
    `${location.pathname}${location.search}${location.hash}`,
    'password_login',
  );
  return target ? `/seek/auth?returnTo=${encodeURIComponent(target)}` : '/seek/auth';
}

export function getForkSeekOnboardingPath(value: string | null | undefined) {
  const continuation = sanitizeForkSeekReturnTo(value, 'paid_plan');
  if (!continuation) return '/seek/onboarding';
  const plan = new URL(continuation, 'https://forkseek-continuation.invalid').searchParams.get('plan');
  const canonicalPlan = normalizeForkSeekPaidPlanKey(plan);
  return canonicalPlan
    ? `/seek/onboarding?plan=${encodeURIComponent(canonicalPlan)}`
    : '/seek/onboarding';
}

export function getForkSeekPostOnboardingPath(plan: string | null | undefined) {
  const canonicalPlan = normalizeForkSeekPaidPlanKey(plan);
  return canonicalPlan
    ? `/seek/settings/subscription?plan=${encodeURIComponent(canonicalPlan)}`
    : null;
}

export function appendForkSeekReturnTo(
  path: string,
  returnTo: string | null | undefined,
  purpose: ForkSeekContinuationPurpose,
) {
  const safeReturnTo = sanitizeForkSeekReturnTo(returnTo, purpose);
  if (!safeReturnTo) return path;

  const [pathname, existingSearch = ''] = path.split('?');
  const params = new URLSearchParams(existingSearch);
  params.set('returnTo', safeReturnTo);
  return `${pathname}?${params.toString()}`;
}
